<template>
  <div v-if="role.bestuurder">
    <XVactionbar>
      <template slot="actionbuttons">
        <div id="pnlButtonBar">
          <div class="btn-group">
            <button type="button" id="btnTerug" class="btn btn-primary btn-xs" @click.prevent="btnTerug">
              <font-awesome-icon icon="chevron-left" />
              {{ translation(16881) }}
            </button>
            <button
              type="button"
              id="btnOpslaan"
              class="btn btn-primary btn-xs"
              @click.prevent="btnOpslaan"
              :disabled="btnToggles.btnOpslaanConcept"
              v-if="!$route.params.conceptId"
            >
              <font-awesome-icon :icon="['far', 'save']" />
              {{ translation(16852) }}
            </button>
            <button
              type="button"
              id="btnOpslaanWijziging"
              class="btn btn-primary btn-xs"
              @click.prevent="btnOpslaanWijziging"
              :disabled="btnToggles.btnWijzigingConcept"
              v-if="$route.params.conceptId"
            >
              <font-awesome-icon :icon="['far', 'save']" />
              {{ translation(16852) }}
            </button>
          </div>
        </div>
      </template>
    </XVactionbar>

    <div class="row" v-if="!$route.params.conceptId">
      <div class="col-12">
        <span id="lblTitel" class="titel">{{ translation(16863) }}</span>
      </div>
    </div>
    <div class="row lblBeschrijving" v-if="translation(16864) !== '' && !$route.params.conceptId">
      <div class="col-12">
        <p v-html="translation(16864)"></p>
      </div>
    </div>
    <div class="row" v-if="$route.params.conceptId">
      <div class="col-12">
        <span id="lblTitel" class="titel">{{ translation(16882) }}</span>
      </div>
    </div>
    <div class="row lblBeschrijving" v-if="translation(16883) !== '' && $route.params.conceptId">
      <div class="col-12">
        <p v-html="translation(16864)"></p>
      </div>
    </div>
    <fieldset class="margin20 margin20bottom">
      <!-- voorletters -->
      <XVbootstraprow
        :label="translation(16865)"
        :required="true"
        :haserror="errors.has('tbxVoorletters')"
        :errormessage="errors.first('tbxVoorletters')"
      >
        <XVinput
          id="tbxVoorletters"
          key="tbxVoorletters"
          name="tbxVoorletters"
          v-model="formInputConcept.tbxVoorletters"
          :formatter="formatVoorletters"
          v-validate="'required|XVvoorletters'"
          :data-vv-as="translation(16865)"
          type="text"
        ></XVinput>
      </XVbootstraprow>
      <!-- tussenvoegsel  -->
      <XVbootstraprow :label="translation(16866)">
        <XVinput
          id="tbxTussenvoegsel"
          key="tbxTussenvoegsel"
          name="tbxTussenvoegsel"
          v-model="formInputConcept.tbxTussenvoegsel"
          type="text"
        ></XVinput>
      </XVbootstraprow>
      <!-- achternaam -->
      <XVbootstraprow
        :label="translation(16867)"
        :required="true"
        :haserror="errors.has('tbxAchternaam')"
        :errormessage="errors.first('tbxAchternaam')"
      >
        <XVinput
          id="tbxAchternaam"
          key="tbxAchternaam"
          name="tbxAchternaam"
          v-model="formInputConcept.tbxAchternaam"
          v-validate="'required'"
          :data-vv-as="translation(16867)"
          type="text"
        ></XVinput>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(16868)"
        :required="true"
        :haserror="errors.has('tbxEmail')"
        :errormessage="errors.first('tbxEmail')"
      >
        <XVinput
          id="tbxEmail"
          key="tbxEmail"
          name="tbxEmail"
          v-model="formInputConcept.tbxEmail"
          v-validate="'required|XVemail'"
          :data-vv-as="translation(16868)"
          type="text"
        ></XVinput>
      </XVbootstraprow>
      <!-- geboortedatum -->
      <XVbootstraprow
        :label="translation(16869)"
        :required="true"
        :haserror="errors.has('tbxGeboortedatum')"
        :errormessage="errors.first('tbxGeboortedatum')"
      >
        <XVdate
          id="tbxGeboortedatum"
          name="tbxGeboortedatum"
          v-model.trim="formInputConcept.iGeboortedatum"
          :data-vv-as="translation(16869)"
          v-validate="{ XVDateDefault: true, required: true }"
        ></XVdate>
      </XVbootstraprow>
      <!-- functie -->
      <XVbootstraprow
        :label="translation(16870)"
        :required="true"
        :haserror="errors.has('rbFunctie')"
        :errormessage="errors.first('rbFunctie')"
      >
        <XVradiobuttonlist
          id="rbFunctie"
          v-model="formInputConcept.rbFunctie"
          :datalist="[
            { value: 1, labelText: 'Adjunct-Directeur' },
            { value: 2, labelText: 'Directeur ' },
            { value: 3, labelText: 'Interim Directeur' },
            { value: 4, labelText: 'Overig' }
          ]"
          v-validate="'required'"
          name="rbFunctie"
          :data-vv-as="translation(16870)"
        ></XVradiobuttonlist>
      </XVbootstraprow>
      <!-- startdatum -->
      <XVbootstraprow
        :label="translation(16871)"
        :required="true"
        :haserror="errors.has('tbxStartDatum')"
        :errormessage="errors.first('tbxStartDatum')"
      >
        <XVdate
          id="tbxStartDatum"
          name="tbxStartDatum"
          v-model.trim="formInputConcept.iStartDatum"
          :data-vv-as="translation(16871)"
          v-validate="{ XVDateDefault: true, required: true }"
        ></XVdate>
        <span class="form-group__message">{{ errors.first('tbxStartDatum') }}</span>
      </XVbootstraprow>
    </fieldset>
  </div>
</template>
<script>
import { FAMixin, util } from 'pevueglobal'
import { sync } from 'vuex-pathify'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  mixins: [FAMixin],
  data: function() {
    return {}
  },
  async mounted() {
    await this.getRole()
    if (this.$route.params.conceptId) {
      await this.fillDataConceptOvereenkomst(parseInt(this.$route.params.conceptId))
    }
  },
  computed: {
    ...mapGetters('SRPOOvereenkomsten', ['role', 'srpoTableConcepten', 'btnToggles']),
    formInputConcept: sync('SRPOOvereenkomsten/formInputConcept')
  },
  methods: {
    ...mapActions('SRPOOvereenkomsten', ['insertOvereenkomstConcept', 'updateOvereenkomstConcept', 'getRole']),
    ...mapMutations(['addNotification']),
    ...mapMutations('SRPOOvereenkomsten', [
      'fillDataConceptOvereenkomst',
      'toggleBtnOpslaanConcept',
      'toggleBtnWijzigingConcept'
    ]),
    btnTerug() {
      this.$router.push({ name: 'overzicht' })
    },
    btnOpslaan() {
      this.toggleBtnOpslaanConcept(true)
      this.$validator.validate().then(result => {
        if (result) {
          let formInputOvereenkomstenConcept = {
            ProfgroupID: parseInt(util.UgetCookie('pe_activeProfGroup'), 10),
            Voorletters: this.formInputConcept.tbxVoorletters,
            Achternaam: this.formInputConcept.tbxAchternaam,
            Email: this.formInputConcept.tbxEmail,
            Geboortedatum: util.DateForDatabaseV2(this.formInputConcept.iGeboortedatum),
            FunctieID: this.formInputConcept.rbFunctie,
            StartDatum: util.DateForDatabaseV2(this.formInputConcept.iStartDatum),
            Tussenvoegsel: this.formInputConcept.tbxTussenvoegsel
          }
          this.insertOvereenkomstConcept(formInputOvereenkomstenConcept)
        } else {
          this.toggleBtnOpslaanConcept(false)
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642)
          })
        }
      })
    },
    btnOpslaanWijziging() {
      this.toggleBtnWijzigingConcept(true)
      this.$validator.validate().then(result => {
        if (result) {
          let formInputOvereenkomstenConcept = {
            Id: this.$route.params.conceptId,
            ProfgroupID: parseInt(util.UgetCookie('pe_activeProfGroup'), 10),
            Voorletters: this.formInputConcept.tbxVoorletters,
            Tussenvoegsel: this.formInputConcept.tbxTussenvoegsel,
            Achternaam: this.formInputConcept.tbxAchternaam,
            Email: this.formInputConcept.tbxEmail,
            Geboortedatum: util.DateForDatabaseV2(this.formInputConcept.iGeboortedatum),
            FunctieID: this.formInputConcept.rbFunctie,
            StartDatum: util.DateForDatabaseV2(this.formInputConcept.iStartDatum)
          }
          this.updateOvereenkomstConcept(formInputOvereenkomstenConcept)
        } else {
          this.toggleBtnWijzigingConcept(false)
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642)
          })
        }
      })
    },
    formatVoorletters(value) {
      if (value.length > 1) {
        value = value
          .replace(/[ ,.]+/g, '')
          .split('')
          .join('.')
          .toUpperCase()
          .concat('.')
        return value
      } else {
        return value.replace(' ', '').toUpperCase()
      }
    }
  }
}
</script>

<style scoped>
fieldset .row:first-child {
  margin-top: 20px;
}
</style>
